import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import TRANSLATIONS_DE from './de/translation.json';
import TRANSLATIONS_EN from './en/translation.json';

// eslint-disable-next-line import/no-named-as-default-member
void i18n
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector)
    .init({
        returnEmptyString: false,
        fallbackLng: 'en',
        resources: {
            en: {
                translation: TRANSLATIONS_EN,
            },
            de: {
                translation: TRANSLATIONS_DE,
            },
        },
    });

// eslint-disable-next-line unicorn/prefer-export-from
export default i18n;
